import {PlaceFinder} from '../common/place-finder';
import {PlacedBin} from '../placed-bin';

type Point = [number, number];

export class ParentCenterPlaceFinder extends PlaceFinder {

    public override produceVariants(): PlacedBin[] {
        const parentPlacedBin = this.placedBins.find(placedBin => placedBin.isParent);

        return parentPlacedBin
            ? [
                this.getParentCenteredVariant(parentPlacedBin),
                ...this.getParentSideCenteredVariants(parentPlacedBin)
            ]
            : [];
    }

    private getParentCenteredVariant(parentPlacedBin: PlacedBin): PlacedBin {
        const {w, h} = this.bin;
        const {x: parentX, y: parentY, w: parentW, h: parentH} = parentPlacedBin;
        const x = Math.round(parentX + (parentW - this.bin.w) / 2);
        const y = Math.round(parentY + (parentH - this.bin.h) / 2);

        const placedBin = PlacedBin.createFromDef({x, y, w, h});

        this.board.adjustPlacedBinPos(placedBin);

        return placedBin;
    }

    private getParentSideCenteredVariants(parentPlacedBin: PlacedBin): PlacedBin[] {
        const {w, h} = this.bin;
        const binHalfW = Math.round(w / 2);
        const binHalfH = Math.round(h / 2);
        const {x: parentX, y: parentY, w: parentW, h: parentH} = parentPlacedBin;
        const parentCenterX = Math.round(parentX + parentW / 2);
        const parentCenterY = Math.round(parentY + parentH / 2);
        const sidePositions: [Point, Point, Point, Point] = [
            [parentX + parentW, parentCenterY - binHalfH], // right center
            [parentCenterX - binHalfW, parentY + parentH], // bottom center
            [parentX - w, parentCenterY - binHalfH], // left center
            [parentCenterX - binHalfW, parentY - h] // top center
        ];

        return sidePositions
            .map(([x, y]) => PlacedBin.createFromDef({x, y, w, h}))
            .filter(placedBin => this.board.isPlacedBinInside(placedBin));
    }

}
